<script>
import CustomDictTag from '@/components/DictCustomTag/index.vue'
import moment from 'moment'
import { mapGetters } from 'vuex'
import { tableMixin } from '@/store/table-mixin'
import { userAssetsPageUserDetail } from '@/api/biz/userDetail'
import { parseTime } from '@/utils/ruoyi'

export default {
  name: 'UserAssetsTable',
  components: { CustomDictTag },
  mixins: [tableMixin],
  props: {
    userId: undefined
  },
  data() {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      // 预览封面
      previewImageVisible: false,
      previewUrl: false,
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        id: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('序号'),
          dataIndex: 'id',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('用户昵称'),
          dataIndex: 'userNickname',
          align: 'center'
        },
        {
          title: this.$t('余额'),
          dataIndex: 'balance',
          align: 'center'
        },
        {
          title: this.$t('冻结金额'),
          dataIndex: 'frozenAmount',
          align: 'center'
        },
        {
          title: this.$t('总消费金额'),
          dataIndex: 'totalExpense',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('总收入金额'),
          dataIndex: 'totalIncome',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('积分'),
          dataIndex: 'points',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('可提现金额'),
          dataIndex: 'withdrawableAmount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('变动时间'),
          dataIndex: 'changeTime',
          scopedSlots: { customRender: 'changeTime' },
          ellipsis: true,
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
    userId(newVal) {
      this.getList()
    }
  },
  methods: {
    parseTime,
    moment,
    getTotal(total) {
      return this.$t('共') + total + this.$t('条')
    },
    getList() {
      if (!this.userId) {
        return
      }
      this.loading = true
      this.queryParam.id = this.userId
      userAssetsPageUserDetail(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    }
  }
}
</script>

<template>
  <a-card>
    <a-table
      :loading="loading"
      :size="tableSize"
      rowKey="id"
      :columns="columns"
      :data-source="list"
      :pagination="false"
      :bordered="tableBordered"
      :scroll="{ x: '160%' }"
    >
      <span slot="changeTime" slot-scope="text, record">
        {{ parseTime(record.changeTime) }}
      </span>
    </a-table>
    <!-- 分页 -->
    <a-pagination
      class="ant-table-pagination"
      show-size-changer
      show-quick-jumper
      :pageSizeOptions="pageSizeOptions"
      :current="queryParam.pageNum"
      :total="total"
      :page-size="queryParam.pageSize"
      :showTotal="total => getTotal(total)"
      @showSizeChange="onShowSizeChange"
      @change="changeSize"
    />
  </a-card>
</template>

<style scoped lang="less">

</style>
